export const CLOSE_NOTIFICATION_DIALOG_EVENT_NAME = "notifcationDialogClosed";

